import styled from 'styled-components';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import * as mixins from 'view/styles/mixins';

export const Error = styled.div`
    ${mixins.borderRadius};
    border: 1px solid ${token('color.border.danger', colors.R500)};
    width: 100%;
    padding: ${token('space.100', '8px')};
    text-align: center;
`;
